// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"749552ac","453":"6960f8a4"}[chunkId] + ".chunk.js";
};